<template>
  <div class="report-detail-wrapper">
    <div class="report-detail" v-sj-loading="reportLoading">
      <template v-if="reportDetail">
        <h4 class="report-title">
          {{ reportDetail.REPORTTITLE }}
        </h4>
        <div class="setting-bar">
          <div class="font-setting">
            <span class="font-label">字号</span>
            <i
              class="icon_xh iconfangda font-plus"
              @click="onFontPlusClick"
            ></i>
            <span class="default-size" @click="summaryFontSize = 15">默认</span>
            <i
              class="icon_xh iconsuoxiao font-less"
              @click="onFontLessClick"
            ></i>
          </div>

          <!-- <div class="language-setting">
            <span>翻译</span>
            <sj-select
              class="language-select"
              size="small"
              :options="languageOptions"
              v-model="languageSelected"
            ></sj-select>
          </div> -->

          <!-- <span class="report-time">{{
            publishDateFormatter(reportDetail.PUBLISHDATE)
          }}</span> -->
          <div class="icon-operation">
            <!-- <i
              class="icon_xh"
              :class="[
                true ? 'iconditu-xing' : 'iconxingzhuang-xingxing',
                { active: 'true' }
              ]"
            ></i>

            <i
              class="icon_xh"
              :class="[
                true ? 'icondianzan_kuai' : 'icondianzan',
                { active: 'true' }
              ]"
            ></i> -->

            <i
              v-if="reportDetail.ORIGIN_URL"
              class="icon_xh iconyunduanxiazai"
              @click="onDownload"
            ></i>
          </div>
        </div>
        <div class="report-into-bar">
          <span class="stock" @click="onStockClick">
            {{ reportDetail.SECURITYNAME }}
          </span>
          <span class="info-content">
            <span class="date">{{
              publishNormalFormatter(reportDetail.PUBLISHDATE)
            }}</span>
            <span class="agency"
              ><span>来源:</span
              ><span>{{ reportDetail.COMPANYNAME }}</span></span
            >
            <span class="author">{{ reportDetail.PERSONNAME }}</span>
          </span>
        </div>
        <div class="article-summary">
          <div class="tabmeo-box">
            <div class="tabmeos">
              <div class="tabmeo">
                免责声明：报告中的所有信息或表述的内容不代表新华财经自身观点及立场或证实其内容的真实性，报告内容及观点仅供参考，不构成任何投资建议，任何人在使用本报告时，应充分咨询所在证券机构和服务人员意见，正确使用报告。如发现违法及不良信息，请拨打电话400-6123115或发送邮件至xinhuacaijing@xinhua.org，我们将及时处理。
              </div>
            </div>
          </div>
        </div>
        <div class="summary-area" v-if="content">
          <p class="summary-title text-title">摘要</p>
          <div
            class="summary-content"
            :style="summaryStyle"
            v-html="content"
          ></div>
        </div>

        <div class="content-area" v-if="reportDetail.ORIGIN_URL">
          <p class="content-title text-title">正文</p>
          <!--判断原文还是pdf-->
          <div v-if="false"></div>
          <div v-else>
            <pdf-viewer :url="reportDetail.URL"></pdf-viewer>
          </div>
        </div>

        <!-- <p class="footer-label"> -->
        <!-- 新华财经信任报告来源机构专业独立性，但报告内容不代表新华财经自身观点及立场或证实其内容真实性；报告内容及观点仅供参考，不构成任何投资建议；任何人在使用本报告时应充分咨询所在机构和服务人员意见，正确使用报告。 -->
        <!-- 免责声明：报告中的所有信息或表述的内容不代表新华财经自身观点及立场或证实其内容的真实性，报告内容及观点仅供参考，不构成任何投资建议，任何人在使用本报告时，应充分咨询所在证券机构和服务人员意见，正确使用报告。如发现违法及不良信息，请拨打电话400-6123115或发送邮件至xinhuacaijing@xinhua.org，我们将及时处理。 -->
        <!-- </p> -->
      </template>
      <SjBlank v-else />
    </div>
  </div>
</template>

<script>
import PdfViewer from "@/views/ReportDetail/components/PdfViewer";
import {
  publishDateFormatter,
  publishNormalFormatter,
  download,
  getCustomPdfLink,
} from "@/utils";
import EventBus from "@/eventBus";

export default {
  name: "index",
  components: { PdfViewer },
  data() {
    return {
      reportId: null,
      reportDetail: null,
      reportLoading: false,
      summaryFontSize: 15,
      viewTime: Date.now(),
      eventData: {},
    };
  },
  computed: {
    summaryStyle() {
      return {
        fontSize: this.summaryFontSize + "px",
      };
    },
    content() {
      const { reportDetail } = this;
      if (reportDetail && reportDetail.INFOBODYCONTENT) {
        return reportDetail.INFOBODYCONTENT.replace(/\n/g, "<br/>");
      }
      return "";
    },
  },
  created() {
    this.reportId = this.$route.query.reportId;
    this.getReportDetail().then(() => {
      this.eventData = {
        content_id: this.reportId,
        content_name: this.reportDetail.REPORTTITLE,
        author_name: this.reportDetail.PERSONNAME,
        upstream_page_type: this.$route.query.upstream_page_type,
        upstream_page_modular: this.$route.query.upstream_page_modular,
        research_report_type: this.$route.query.research_report_type
          ? this.$route.query.research_report_type
          : "个股",
        content_read_duration: 0,
      };
    });
    window.onbeforeunload = (e) => {
      if (!this.reportDetail) {
        return;
      }
      this.eventData.content_read_duration = Date.now() - this.viewTime;
      window.localStorage.setItem(
        "view_research_report_page",
        JSON.stringify(this.eventData)
      );
    };
  },
  methods: {
    onStockClick() {
      EventBus.$emit("showStockDialog", this.reportDetail);
    },
    publishNormalFormatter,
    publishDateFormatter,
    async getReportDetail() {
      if (!this.reportId) return;
      try {
        this.reportLoading = true;
        const { data } = await this.$apis.ReportDetail.getReportDetail({
          V_INFOCODE: this.reportId,
        });
        if (data.length) {
          this.reportDetail = data[0];
        }
      } finally {
        this.reportLoading = false;
      }
    },

    onFontLessClick() {
      if (this.summaryFontSize > 12) {
        this.summaryFontSize--;
      } else {
        return;
      }
      if (!this.reportDetail) {
        return;
      }
      window.sendEvent("research_report_page_operation", {
        content_id: this.reportId,
        content_name: this.reportDetail.REPORTTITLE,
        author_name: this.reportDetail.PERSONNAME,
        translation_language: "中文",
        research_report_type: this.$route.query.research_report_type
          ? this.$route.query.research_report_type
          : "个股",
        operation_type: "字号缩小",
      });
    },

    onFontPlusClick() {
      this.summaryFontSize++;
      if (!this.reportDetail) {
        return;
      }
      window.sendEvent("research_report_page_operation", {
        translation_language: "中文",
        content_id: this.reportId,
        content_name: this.reportDetail.REPORTTITLE,
        author_name: this.reportDetail.PERSONNAME,
        research_report_type: this.$route.query.research_report_type
          ? this.$route.query.research_report_type
          : "个股",
        operation_type: "字号放大",
      });
    },

    onDownload() {
      const { reportDetail } = this;
      if (!reportDetail) {
        return;
      }
      let username = this.$store.state.username;
      let nickname = this.$store.state.nickname;
      let url = getCustomPdfLink(reportDetail.URL, username, nickname);
      download(url, reportDetail.F_NAME);
      window.sendEvent("research_report_page_operation", {
        translation_language: "中文",
        content_id: this.reportId,
        content_name: this.reportDetail.REPORTTITLE,
        author_name: this.reportDetail.PERSONNAME,
        research_report_type: this.$route.query.research_report_type
          ? this.$route.query.research_report_type
          : "个股",
        operation_type: "下载",
      });
    },
  },
};
</script>

<style scoped lang="less">
.report-detail-wrapper {
  overflow-y: scroll;
  height: 100%;
}
.report-detail {
  margin: auto;
  width: 1000px;
  background-color: white;
  padding: 50px 90px;
  box-sizing: border-box;
  overflow: hidden;
  font-family: "微软雅黑,Microsoft YaHei,Arial";
  // color: @color-normal;
  // font-size: @xh-font-size;
  color: @color-normal;
  font-size: 14px;
  min-height: 100%;

  .report-title {
    color: @color-dark;
    font-size: 16px;
    margin: 0 0 13px;
  }

  .setting-bar {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    font-size: @xh-font-size;

    .font-setting {
      display: flex;
      align-items: center;
      .font-label {
        margin-right: 20px;
      }

      .default-size {
        margin: 0 3px;
        color: @color-highlight-xh;
        cursor: pointer;
      }

      .font-plus,
      .font-less {
        cursor: pointer;
        &:hover {
          color: @color-highlight-xh;
        }
      }
    }

    // .language-setting {
    //   display: flex;
    //   align-items: center;
    //   margin-left: 10px;

    //   .language-select {
    //     width: 75px;
    //     margin-left: 10px;
    //   }
    // }

    .report-time {
      margin-left: auto;
    }

    .icon-operation {
      display: flex;
      font-size: 14px;
      align-items: center;
      margin-left: auto;
      .icon_xh {
        cursor: pointer;
        margin-left: 14px;
        // &.active {
        //   color: @color-highlight-xh;
        // }
      }
    }
  }

  .report-into-bar {
    display: flex;
    align-items: center;
    font-size: @xh-font-size;
    margin-bottom: 20px;

    .stock {
      cursor: pointer;
      margin-left: 10px;
      color: @color-highlight-xh;
    }
    .info-content {
      flex: 1;
      text-align: center;
      span {
        margin-left: 10px;
      }
    }
  }

  .text-title {
    font-size: 16px;
    font-weight: 500;
    color: #399bff;
    position: relative;
    padding-left: 12px;
    &:before {
      position: absolute;
      width: 5px;
      top: 0;
      left: 0;
      bottom: 0;
      content: "";
      background-color: #399bff;
    }
  }
  .article-summary {
    color: @color-normal;
    line-height: 20px;
    text-align: justify;
    // padding: 0 40px
  }
  .tabmeo-box {
    text-align: left;
    background: #f2f2f2;
    padding: 6px 14px;
    position: relative;
    margin-bottom: 12px;
    &:before {
      position: absolute;
      content: "";
      width: 5px;
      height: 100%;
      background: #808c9a;
      left: 0;
      top: 0;
    }
    .tabmeo {
      line-height: 30px;
      text-indent: 20px;
      font-size: 14px;
    }
  }
  .summary-area {
    .summary-content {
      color: black;
      margin-top: 5px;
      line-height: 2;
    }
  }

  .content-area {
    margin-top: 30px;
    .content-title {
      margin-bottom: 15px;
    }
  }

  .footer-label {
    margin-top: 20px;
    padding-top: 15px;
    border-top: 1px #ebebec solid;
    color: #97a3b4;
    font-size: 12px;
  }
}
.dark-theme {
  .report-detail {
    .article-summary {
      .tabmeo-box {
        background: #162c46;
      }
    }
  }
}
</style>
